import { useMemo } from "react";
import { useEditItem2 } from "../../../api/useNewItem";
import { FieldType, mergeSchema, Schema } from "../../../hooks/useSchema";
import { FileInfo, useFileList } from "../../files";
import { useCRMContext } from "../CRMContext";
import { useItemActionWithConfirmation } from "../../../api/useAction";

export interface CRMDocument {
  _id: string;
  filename: string;
  // title: string;
  comment: string;
}


// type AttachedWithFileInfo = AttachedDocument & { fileinfo: FileInfo };

const fileInfoToDocument = (fi: FileInfo): CRMDocument & { fileinfo: FileInfo } => ({
  _id: fi._id,
  filename: fi.filename,
  // title: fi.meta?.title || "",
  comment: fi.meta?.comment || "",
  fileinfo: fi,
});

const ContactFileSchema: Schema = {
  comment: { label: "Комментарий", type: FieldType.textlong },
}

export const useContactFiles = (
  contactId: string | undefined
) => {
  const ctx = useCRMContext();
  const baseApiPath = `${ctx.apiPath}/contact/${contactId}/document`;
  const filelist = useFileList(baseApiPath, undefined, {
    noLoad: !contactId,
  });

  const editItem = useEditItem2<CRMDocument>({
    getApiPath: doc => `${baseApiPath}/${doc._id}/info`,
  });

  // if reordering is needed: useAttachedDocuments in biodiv
  
  const files = useMemo(() => {
    const processed = filelist.data.map(fileInfoToDocument);
    return processed;
  }, [filelist.data]);

  const removeItem = useItemActionWithConfirmation<FileInfo, {}>(
    async (d) => { await filelist.remove(d); return {}; }, {
      title: "Удалить файл"
    });

  return {
    ...filelist,
    schema: mergeSchema(filelist.schema, ContactFileSchema),
    data: files,
    editItem: {
      ...editItem,
      save: () => editItem.save().then(x => { filelist.reload(); return x; }),
    },
    removeItem,
  }
};

export type ContactFilesData = ReturnType<typeof useContactFiles>;